import { isPlatformBrowser } from "@angular/common";
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    Inject,
    PLATFORM_ID,
} from "@angular/core";
import Hotjar from "@hotjar/browser";
import { environment } from "../environments/environment";
import { MainComponent } from "./modules/main/components/main/main.component";

@Component({
    selector: "ls-root",
    imports: [
        MainComponent,
    ],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
  })
export class AppComponent implements AfterViewInit {

    constructor(@Inject(PLATFORM_ID) private platformId: object) {
    }

    public ngAfterViewInit(): void {
        if (environment.domain === "PROD" && isPlatformBrowser(this.platformId)) {
            const siteId = 3847267;
            const hotjarVersion = 6;
            Hotjar.init(siteId, hotjarVersion);
            console.warn("hj enabled");
        }
    }

}
